module.exports = __webpack_public_path__ + "static/media/sql.f7b2efe7.png";